import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import WorldLink from './Operator/WorldLink';
import ViaNet from './Operator/ViaNet';
import BroadLink from './Operator/BroadLink';
import ADSL from './Operator/ADSL';
import NTFTTH from './Operator/NTFTTH';
import Subisu from './Operator/Subisu';
import TechMind from './Operator/TechMind';
import ArrowNet from './Operator/ArrowNet';
import PokhraInternet from './Operator/PokhraInternet';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function WifiInternet() {
  const [operatorCode, setOperatorCode] = useState(false);
  const [providers, setProviders] = useState(false);
  const getOperatorCode = (e) => {
    setOperatorCode(e.target.value);
  };
  const getData = async () => {
    try {
      const response = await axios.get('/admin/get/all/providers/NEPALESE', { params: { category_name: "WiFi Internet Bills Pay" } });
      const { status, data } = response.data;
      if (status) {
        setProviders(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <div className="row">
        <div class="col-lg-12 col-md-12">
          <label>Operator</label>
          <select class="form-control" name="OperatorCode" onChange={getOperatorCode}>
            <option value="">--Select--</option>
            {
              (providers && providers.length > 0) && providers.map((provider) => (
                provider.status == "Active" && (
                  <option value={provider._id}>{provider.provider_name}</option>
                )
              ))
            }
          </select>
        </div>
        {
          operatorCode && (
            <>
              {
                operatorCode == "663b2cb9c1eb778b43da4102" ? (
                  <>
                    <WorldLink operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67fe3a7397f3f263fdcee3af" ? (
                  <>
                    <ViaNet operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff4540e77e42c9398cfae0" ? (
                  <>
                    <BroadLink operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff4ac8e77e42c9398cfae1" ? (
                  <>
                    <ADSL operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff4ad3e77e42c9398cfae2" ? (
                  <>
                    <NTFTTH operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff62a5e77e42c9398cfae3" ? (
                  <>
                    <Subisu operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff7fcee77e42c9398cfae4" ? (
                  <>
                    <TechMind operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ff8642e77e42c9398cfae5" ? (
                  <>
                    <ArrowNet operatorCode={operatorCode} />
                  </>
                ) : operatorCode == "67ffa38be77e42c9398cfae8" ? (
                  <>
                    <PokhraInternet operatorCode={operatorCode} />
                  </>
                ) : ""
              }
            </>
          )
        }
      </div>
    </>
  );
}

export default WifiInternet;
